import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Inject, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { GridModule } from '@progress/kendo-angular-grid';
import { oktaToken } from '../../../../models/okta-token.model';
import { createSettings } from '../../models/createSettings.model';
import { SettingService } from '../../services/settingservice';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { CommonService } from '../../../question/services/commonservice';
// Import ISG Shared Components
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid';
import { GridColumnFactory } from '@mysrc/app/shared/utils/grid-column-factory';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { dateValueFormatter } from '@mysrc/app/shared/utils/date-formatter';

@Component({
  selector: 'createsettings',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, GridModule, NgbModule, AgGridAngular, IsgGridComponent],
  templateUrl: './createsettings.component.html',
  styleUrls: ['./createsettings.component.css'],
  providers: [CommonService,SettingService, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CreateSettingsComponent extends BaseHttpReqRespService {

  @ViewChild('deleteSettingModelConfirmation') deleteSettingModelConfirmation!: TemplateRef<any>;

  modalRef: NgbModalRef | undefined;
  success: boolean = false;

  sectionForm!: FormGroup;
  private gridApi: any;
  public settingSectionMappedList: createSettings[] = [];
  public settingSectionUnMappedlist: createSettings[] = [];
  public sectionId: string = '';
  public settingId: string = '';
  public settingName: string = '';
  public mapSections: string[] = [];
  public mapOrderedSections: string[] = [];
  public unMapSections: string[] = [];
  public callTableDragger: boolean = false;
  public successOrFailureMessage: string = '';
  public isMappedButton: boolean = false;
  public currentDeleteId: number = 0;
  public gridPageSize = 10;
  public gridSkip = 0;
  public myAppUrl: any;
  public oktaTokenDetails!: oktaToken;

  defaultsectionMappedListColDef: ColDef = {
    sortable: false,
    filter: true,
    resizable: true
  };

  defaultsectionUnmappedListColumnDefs: ColDef = {
    sortable: true,
    filter: true,
    resizable: true
  };

  // ISG Grid configuration for consistent styling
  mappedSectionGridConfig: Partial<IsgGridConfig> = {
    height: '500px',
    pagination: true,
    pageSize: 10,
    autoSizeColumns: true
    //rowDragManaged:true
  };

  unmappedSectionGridConfig: Partial<IsgGridConfig> = {
    height: '500px',
    pagination: true,
    pageSize: 10,
    autoSizeColumns: true
  };

  sectionMappedListColumnDefs: ColDef[] = [
    { headerName: '', field: 'rowSelect', width: 10, suppressMenu: true, suppressHeaderMenuButton: true, checkboxSelection: true, headerCheckboxSelection: true, resizable: true },
    { headerName: 'SettingId', field: 'settingId', hide: true },
    { headerName: 'SectionId', field: 'sectionId', hide: true },
    { headerName: 'SectionSettingMapId', field: 'sectionSettingMapId', hide: true },
    { headerName: 'Section Name', field: 'sectionName', rowDrag: true, resizable: true, width: 200 }
  ];

  sectionUnmappedListColumnDefs: ColDef[] = [
    { headerName: '', field: 'rowSelect', width: 40, suppressHeaderMenuButton: true, sortable: false, checkboxSelection: true, headerCheckboxSelection: true, resizable: true },
    { headerName: 'SectionId', field: 'sectionId', hide: true },
    { headerName: 'Section Name', field: 'sectionName', width: 420, resizable: true }
  ];

  constructor(
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private route: ActivatedRoute,
    protected http: HttpClient,
    private EncrDecr: EncrDecrService,
    private _router: Router,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
    private modalService: NgbModal,
    private settingService: SettingService,
    @Inject('BASE_URL') baseUrl: string
  ) {
    super(http, oauth);
    this.myAppUrl = baseUrl;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.settingId = params['settingId'];
      this.settingName = params['settingName'];
    });
    this.getMappedSections();
    this.AddSection();
  }

  //onRowDragEnd(event: any) {
  //  const movingNode = event.node;
  //  const overNode = event.overNode;
  //  if (!overNode || movingNode === overNode) return;

  //  // Remove the moving row from its old position
  //  const movingData = movingNode.data;
  //  const fromIndex = this.settingSectionMappedList.findIndex(d => d.sectionId === movingData.sectionId);
  //  this.settingSectionMappedList.splice(fromIndex, 1);

  //  // Insert the moving row at the new position
  //  const toIndex = this.settingSectionMappedList.findIndex(d => d.sectionId === overNode.data.sectionId);
  //  this.settingSectionMappedList.splice(toIndex, 0, movingData);

  //  // Refresh the grid
  //  event.api.setRowData(this.settingSectionMappedList);
  //}

  onGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

  BackUrl() {
    this._router.navigate(['/setting']);
  }

  CloseForm() {
    this.sectionForm.reset();
  }

  openAddSectionModal(modalRef: any) {
    this.AddSection();
    this.modalService.open(modalRef, { size: 'lg', backdrop: 'static' });
  }

  getUnMappedSections() {
    this.settingService.getUnMappedSections(this.settingId, this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '')).subscribe(result => {
      this.settingSectionUnMappedlist = result;
    }, error => console.error(error));
  }

  getMappedSections() {
    this.settingService.getMappedSections(this.settingId).subscribe(result => {
      this.settingSectionMappedList = result;
    }, error => console.error(error));
  }

  AddSection() {
    this.sectionForm = this.formBuilder.group({});
    this.getUnMappedSections();
  }

  unMapSection() {
    this.settingService.unMapSection(this.settingId, this.unMapSections).subscribe(result => {
      this.settingSectionMappedList = result;
      this.successOrFailureMessage = "Section(s) unmapped successfully.";
      this.messageTimeout();
      this.unMapSections = [];
    }, error => console.error(error));
    this.sectionForm.reset();
  }

  fn_mapSection() {
    this.settingService.mapSection(this.settingId, this.mapSections).subscribe(result => {
      this.settingSectionMappedList = result;
      this.successOrFailureMessage = "Section(s) mapped successfully.";
      this.messageTimeout();
      this.mapSections = [];
    }, error => console.error(error));
    this.sectionForm.reset();
  }

  arrangeOrder() {
    let orderedSectionIdList = '';
    this.gridApi.forEachNode((rowNode: any) => {
      orderedSectionIdList = orderedSectionIdList + rowNode.data.sectionId + ',';
    });
    this.settingService.arrangeOrder(this.settingId, orderedSectionIdList).subscribe(result => {
      this.settingSectionMappedList = result;
      this.successOrFailureMessage = "Section(s) arranged successfully.";
      this.messageTimeout();
      this.mapOrderedSections = [];
      this.mapSections = [];
      this.unMapSections = [];
    }, error => console.error(error));
    this.sectionForm.reset();
  }

  messageTimeout() {
    window.setTimeout(() => {
      this.successOrFailureMessage = '';
    }, 3500);
  }

  onRowSelected(params: any) {
    if (params.node.selected) {
      if (params.data.sectionSettingMapId > 0) {
        this.unMapSections.push(params.data.sectionId);
      } else {
        this.mapSections.push(params.data.sectionId);
      }
    } else {
      if (params.data.sectionSettingMapId > 0) {
        const index = this.unMapSections.indexOf(params.data.sectionId);
        if (index !== -1) this.unMapSections.splice(index, 1);
      } else {
        const index = this.mapSections.indexOf(params.data.sectionId);
        if (index !== -1) this.mapSections.splice(index, 1);
      }
    }
  }
}

